import React from "react";
import iconThongTinTk from "Resources/ImagesNew/iconThongTinTk.png";
import iconCaiDat from "Resources/ImagesNew/Icons-Settings.png";
import iconDangXuat from "Resources/ImagesNew/Icons-Logout.png";
import { getUrl } from "utils/utils";
import { getUserLogin } from "utils/utils";

export const SidebarAccount = [
  // {
  //   title: "Thông tin tài khoản",
  //   path: "/Thong-tin-tai-khoan",
  //   icon: iconThongTinTk,
  // },
  {
    title: "Đổi mật khẩu",
    path: "/Users/MKNguoiDung",
    icon: iconCaiDat,
  },
  {
    title: "Đăng xuất",
    path: "/DangNhap",
    icon: iconDangXuat,
  },
];
